import axios from "axios";
import constants from "../common/utils/constants";
import { useDebugValue } from "react";

const axiosClient = axios.create();


axiosClient.defaults.baseURL = constants.HOST_URL;


axiosClient.defaults.headers = constants.headers;

// To share cookies to cross site domain, change to true.
axiosClient.defaults.withCredentials = false;

axiosClient.interceptors.request.use(function (config) {
  var token = localStorage.getItem("token_bearer");
  var token_type = localStorage.getItem("token_type");
  var authHeader = `${token_type} ${token}`;
  config.headers.Authorization = authHeader;

  // Let the browser set multipart boundary for file uploads.
  if (config.data instanceof FormData && config.headers) {
    if (typeof config.headers.delete === "function") {
      config.headers.delete("Content-Type");
    } else {
      delete config.headers["Content-Type"];
    }
  }

  return config;
});

export function getRequest(URL) {
  return axiosClient.get(`/${URL}`).then((response) => response);
}

export function postRequest(URL, payload) {
  return axiosClient.post(`/${URL}`, payload).then((response) => response);
}

export function postFormDataRequest(URL, formData, config = {}) {
  return axiosClient
    .post(`/${URL}`, formData, {
      ...config,
      headers: {
        ...(config.headers || {}),
        Accept:
          config.responseType === "blob"
            ? "application/pdf, application/json"
            : "application/json",
      },
    })
    .then((response) => response);
}

export function patchRequest(URL, payload) {
  return axiosClient.patch(`/${URL}`, payload).then((response) => response);
}

export function deleteRequest(URL) {
  return axiosClient.delete(`/${URL}`).then((response) => response);
}
